import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import { CATEGORY_ID } from '@/config/constants';
import { KidsMenu, KidsMenuPictures } from '@/apps/menu/constants';
import { CONFIGURATOR_PRODUCT } from '@/apps/configurator/store/types';

/**
 * Screen to provide kids menu selection
 */
@Component
export default class KidsMenuMixin extends Vue {
  @Getter productByKey;
  @Getter categoryByKey;
  @Action(CONFIGURATOR_PRODUCT) setCurrentProduct;

  /**
   * List of kids menu product
   */
  get products() {
    return KidsMenu.SUB_PRODUCTS;
  }


  /**
   * Retrieve current product by key;
   * @param productId
   * @returns {*}
   */
  product(productId) {
    return {
      ...this.productByKey(productId),
      image: KidsMenuPictures[productId],
    };
  }

  /**
   * Get id of the first category for current product.
   * @param productKey
   * @returns {number}
   */
  getFirstCategoryId(productKey) {
    switch (productKey) {
      case (KidsMenu.KIDS_GRILLED_CHEESE):
        return CATEGORY_ID.KIDS_GRILLED_CHEESE;

      // case (KidsMenu.KIDS_CHICKEN_STRIPS):
      //   return CATEGORY_ID.GRILLED_CHICKEN_STRIPS;

      case (KidsMenu.KIDS_TREASURE_BOX):
        return CATEGORY_ID.KIDS_TREASURE_BOX;

      case (KidsMenu.KIDS_BURGER):
        return CATEGORY_ID.KIDS_BURGER;

      default:
        return CATEGORY_ID.KIDS_GRILLED_CHEESE;
    }
  }

  /**
   * Open configurator for passed product key
   * @param productKey
   * @returns {Promise<void>}
   */
  async openConfigurator(productKey) {
    const firstCategoryId = this.getFirstCategoryId(productKey);
    const firstCategory = this.categoryByKey(firstCategoryId);

    if (firstCategory.items.length === 1) {
      await this.setCurrentProduct({
        productKey,
        orderItem: {
          [firstCategoryId]: {
            [firstCategory.items[0]]: Object.assign({ quantity: 1 }),
          },
        },
      });
    } else {
      await this.setCurrentProduct({ productKey });
    }
    this.$router.push({ name: 'configurator', params: { id: productKey } });
  }
}



// WEBPACK FOOTER //
// ./src/apps/menu/mixins/kids-menu-mixin.js